import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src2017366789/src/src/layouts/default.vue").then(m => m.default || m)),
  "with-global-nav": defineAsyncComponent(() => import("/codebuild/output/src2017366789/src/src/layouts/withGlobalNav.vue").then(m => m.default || m))
}